export const defaultIntelFormData = {
    // 模式
    composition: {
        // 组合（背景替换）：combination
        // 纯背景（图片生成）：background
        // 仅主体：mainBody
        type: 'background',
        value: {
            // 居中：center
            // 居左：left
            // 居右：right
            // 居上：top
            // 居下：bottom
            position: 'bottom', // 默认居下
            // 偏小：small
            // 标准：middle
            // 偏大: large
            size: 2
        }
    },
    // 创意风格
    creativeStyle: {
        image: [{
            url: 'https://feed-image.baidu.com/0/pic/-1548999946_-335483449_-1617167698.png',
            degree: 2,
            type: [
                {
                    label: '通用风格',
                    name: 'creativeStyle',
                    value: 'commonStyle'
                }
            ]
        }]
    },
    // 参考图
    referPic: {
        image: [{
            degree: 2
        }]
    },
    // // 参考强度
    // referDegree: {
    //     value: 2
    // },
    // 尺寸
    sizeControl: {
        // 选择：choose
        // 自定义：'custom'
        type: 'choose',
        value: {
            ratio: '16:9',
            dimension: '1140*640',
            customWidth: '',
            customHeight: ''
        }
    },
    // 背景
    bgControl: {
        type: 'generate',
        value: {
            prompt: '',
            aiPrompt: ''
        }
    }
};

export const defaultDesignFormData = {
    templateGroup: {
        industry: {
            value: ''
        },
        sizeControl: {
            // 选择：choose
            // 自定义：custom
            type: 'choose',
            value: {
                ratio: '16:9',
                dimension: '1140*640',
                customWidth: '',
                customHeight: ''
            }
        },
        template: {
            chooseList: []
        },
        showOuterChoose: true,
        showCheckedCon: false
    },
    // 品牌logo
    brandLogo: {
        image: []
    },
    // 主标题
    mainText: {
        value: ''
    },
    // 副标题
    descText: {
        value: ''
    },
    // 按钮文案
    buttonText: {
        value: ''
    },
    // 其他文案
    otherText: {
        value: ''
    },
    // 品牌文案
    brandText: {
        value: ''
    },
    // 业务点
    businessPointB2B: {
        value: ''
    },
    // 卖点1
    sellingPointFirst: {
        value: ''
    },
    // 卖点2
    sellingPointSecond: {
        value: ''
    },
    // 卖点3
    sellingPointThird: {
        value: ''
    },
    // 厂商名称
    manufacturerName: {
        value: ''
    },
    // 风险提示语
    riskText: {
        value: ''
    }
};

export const defaultB2bSizeControl =  {
    type: 'choose',
    value: {
        ratio: '1:1',
        dimension: '240*240',
        customWidth: '',
        customHeight: ''
    }
};

export const defaultB2BTemplateGroup = {
    industry: {
        value: ''
    },
    sizeControl: {
        // 选择：choose
        // 自定义：custom
        type: 'choose',
        value: {
            ratio: '1:1',
            dimension: '240*240',
            customWidth: '',
            customHeight: ''
        }
    },
    template: {
        chooseList: []
    },
    showOuterChoose: true,
    showCheckedCon: false
};